var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "top_info top_info_container market_cap"
  }, [_c('p', {
    staticClass: "heading"
  }, [_vm._v("market cap")]), _c('p', {
    staticClass: "content usd-before"
  }, [_vm._v(_vm._s(_vm.convertNum(_vm.marketCap)) + " USD")]), _c('p', {
    staticClass: "description dcm-after"
  }, [_vm._v(_vm._s(_vm.inDCM.toLocaleString('en-US')))])]);
}
var staticRenderFns = []

export { render, staticRenderFns }